import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonialsData = [
  {
    id: 1,
    name: 'Michael Chen',
    company: 'Digital Commerce Pro',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: 'Outstanding work! The AI automation solution delivered by AION WISE perfectly matched our requirements. Their communication throughout the project was excellent and the final result exceeded our expectations.',
    metric: '50% efficiency increase'
  },
  {
    id: 2,
    name: 'Lisa Rodriguez',
    company: 'Growth Marketing Agency',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: 'Professional, reliable, and incredibly talented team. They understood our vision for AI chatbots and brought it to life better than we imagined. The ongoing support has been exceptional.',
    metric: '40% cost reduction'
  },
  {
    id: 3,
    name: 'David Kumar',
    company: 'Innovation Labs',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: 'Working with AION WISE was a game-changer for our business. Their technical expertise in machine learning and innovative approach helped us achieve results we never thought possible.',
    metric: '200% growth in users'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">What Our Clients Say</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Real results from real businesses who trusted us with their AI transformation
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {testimonialsData.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-900 border border-gray-700 rounded-xl p-8 hover:border-orange-500 transition-all duration-300 group relative"
            >
              <Quote className="absolute top-6 right-6 w-12 h-12 text-orange-500/20 group-hover:text-orange-500/40 transition-colors" />
              
              <div className="relative">
                <div className="flex items-center gap-4 mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-orange-500"
                  />
                  <div>
                    <h4 className="text-white font-bold">{testimonial.name}</h4>
                    <p className="text-gray-400 text-sm">{testimonial.company}</p>
                  </div>
                </div>

                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>

                <p className="text-gray-300 leading-relaxed mb-4">"{testimonial.text}"</p>

                <div className="bg-orange-600/10 border border-orange-500/30 rounded-lg p-3 inline-block">
                  <p className="text-orange-400 font-semibold text-sm">✨ {testimonial.metric}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center bg-gray-900 border border-gray-700 rounded-xl p-8">
          <div className="flex items-center justify-center gap-4 mb-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="text-3xl font-bold text-white">4.9/5</span>
          </div>
          <p className="text-gray-400">Average Rating</p>
          <p className="text-orange-400 font-semibold mt-1">Based on 500+ client reviews</p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;